<template>
    <div>
        <i class="fa fa-times fa-2x w3-text-gray cursor-pointer card-closer flow-padding-top"
           @click="onClose"
           :title="$t('close')">
        </i>

        <h3 class="flow-blue-color flow-margin-left flow-form-title font-weight-bold">
            <i class="fa fa-print flow-margin-right fa-lg"></i>
            {{ $t('print') }}
        </h3>


        <h4 class="flow-blue-color flow-form-title">
            <patient-name-header :props-patient="selectedPatient"></patient-name-header>
        </h4>


        <print-patient :selected-patient="selectedPatient"></print-patient>
    </div>

</template>

<script>
    import Vue from 'vue';
    import PatientNameHeader from "../common/PatientNameHeader";
    import PrintPatient from "./PrintPatient";

    const frc = Vue.prototype.$frc;

    export default {
        name: "PrintPatientSideCard",
        components: {PrintPatient, PatientNameHeader},
        props: ['selectedPatient', 'onClose']
    }
</script>